// Auto generated file, do not manually modify!
// com.hotpads.leasing.client.enums.LeaseArtifactType

export enum LeaseArtifactType {
  LEASE = 'lease',
  LEASE_EXTENSION_RENEWAL = 'lease_extension_renewal',
}

export const LeaseArtifactType_values = [LeaseArtifactType.LEASE, LeaseArtifactType.LEASE_EXTENSION_RENEWAL] as const;
